import { MapTo } from '@adobe/aem-react-editable-components';
import CreditOneFriends, { CreditOneFriendsEditConfig } from './CreditOneFriends';

export default MapTo('cob-corp-acquisition/components/creditonebank/credit-one-friends')(CreditOneFriends, CreditOneFriendsEditConfig);